import { Form } from 'factorial-form'
import { EmployeeForSelectFragment } from 'generated/resources/graphql'
import { computed, makeObservable } from 'mobx'
import { $Values } from 'utility-types/dist/utility-types'

import i18n from 'modules/core/lib/i18n'

export const TIME_PERIODS = {
  CUSTOM_PERIOD: 'custom-period',
  DAILY: 'daily',
  DOES_NOT_REPEAT: 'does-not-repeat',
} as const

export type TimePeriod = $Values<typeof TIME_PERIODS>

declare type Values = {
  apply_on_days?: string
  start_date?: string
  end_date?: string
  employee_id?: number
  time_period?: string
}

class CommonSelectorsForm extends Form {
  employees?: EmployeeForSelectFragment[] | undefined

  constructor(values: Values = {}) {
    super(values, {
      apply_on_days: 'string',
      start_date: 'string',
      end_date: 'string',
      employee_id: 'number',
      time_period: 'string',
    })

    makeObservable(this, {
      timePeriod: computed,
      isCustomPeriod: computed,
      doesNotRepeat: computed,
    })
  }

  get timePeriod(): TimePeriod {
    return this.get('time_period').value
  }

  get isCustomPeriod(): boolean {
    return this.timePeriod === TIME_PERIODS.CUSTOM_PERIOD
  }

  get doesNotRepeat(): boolean {
    return this.timePeriod === TIME_PERIODS.DOES_NOT_REPEAT
  }

  validate(): boolean {
    this.resetErrors()

    if (!this.get('employee_id').hasValue)
      this.get('employee_id').setErrors([
        i18n.t('shift_management.actions_sidepanel.errors.no_employees'),
      ])

    return !this.hasErrors
  }
}

export default CommonSelectorsForm
